jQuery(document).ready(function ($) {
  //##############################//
  //###*****   Solution Content   *****###//
  //#############################//

  if ($(".m-solutions__content")) {
    $(".m-solutions__content").wrapAll(
      '<div class="m-solutions__content-wrapper" id="content-wrapper" />'
    );
  }

  $(".m-solutions__nav")
    .next(".m-solutions__content-wrapper")
    .andSelf()
    .wrapAll('<div class="m-solutions" id="solution-wrapper" />');

  $(".m-solutions__nav__list li.is-active").each(function () {
    var id = $(this).find(".m-solutions__nav__link").attr("data-tab");
    $("#" + id).addClass("is-active");
  });

  $(".m-solutions__nav__list li:first-of-type .m-solutions__nav__link").each(
    function () {
      $(this).addClass("is-active");
      $(this)
        .closest(".m-solutions__nav")
        .next()
        .find(".m-solutions__content:first")
        .addClass("is-active");
    }
  );

  // add and remove active class to active tab and tab content

  $(".m-solutions__nav__link").click(function (e) {
    e.preventDefault();
    var tab_id = $(this).attr("data-tab");
    console.log("clicked");
    $(".m-solutions__nav__link").removeClass("is-active");
    $(".m-solutions__content").removeClass("is-active");
    $(this).addClass("is-active");
    $(".m-solutions__content#" + tab_id).addClass("is-active");
  });
});
